import { useTheme } from '@mui/material';
import { IconProps } from '@phosphor-icons/react';

import { Spacer } from 'theSource/components/Spacer';
import {
  NoResultsMessageStyled,
  NoResultsMessageWrapperStyled,
} from './NoResultsMessageStyled';

interface NoResultsMessageProps {
  IconComponent: React.ForwardRefExoticComponent<
    IconProps & React.RefAttributes<SVGSVGElement>
  >;
  message: string;
  testId?: string;
}

export const NoResultsMessage = ({
  IconComponent,
  testId = 'no-results-message',
  message,
}: NoResultsMessageProps) => {
  const theme = useTheme();

  return (
    <NoResultsMessageWrapperStyled data-testid={testId}>
      <IconComponent
        size={72}
        color={theme.palette.primary.main}
        weight="thin"
        data-testid="no-results-icon"
        aria-hidden="true"
        role="presentation"
      />
      <Spacer height={1} />
      <NoResultsMessageStyled variant="body1">{message}</NoResultsMessageStyled>
    </NoResultsMessageWrapperStyled>
  );
};
